import { render, staticRenderFns } from "./popup-button.vue?vue&type=template&id=36f95ddd&scoped=true&"
import script from "./popup-button.vue?vue&type=script&lang=js&"
export * from "./popup-button.vue?vue&type=script&lang=js&"
import style0 from "./popup-button.vue?vue&type=style&index=0&id=36f95ddd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f95ddd",
  null
  
)

export default component.exports